export default __webpack_public_path__ + "static/media/bonusStart.ae273a44.mp3";